import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52b9bff4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9bff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b9bff4')) {
      api.createRecord('52b9bff4', component.options)
    } else {
      api.reload('52b9bff4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52b9bff4&scoped=true", function () {
      api.rerender('52b9bff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/noticeTemplateManage/index.vue"
export default component.exports